import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const MultiLanguage = makeShortcode("MultiLanguage");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <MultiLanguage mdxType="MultiLanguage">
      <pre><code parentName="pre" {...{
          "className": "language-js-web"
        }}>{`posthog.group('company', 'company_id_in_your_db');
// For this session, any event captured after calling \`posthog.group\` will be associated with company \`company_id_on_your_db\`
posthog.capture('user_signed_up')
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-python"
        }}>{`posthog.capture(
    '[user distinct id]',
    'user_signed_up',
    groups={'company': 'company_id_in_your_db'}
)
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-go"
        }}>{`client.Enqueue(posthog.Capture{
    DistinctId: "[user distinct id]",
    Event: "user_signed_up",
    Groups: posthog.NewGroups().
        Set("company", "company_id_in_your_db").
})
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-node"
        }}>{`posthog.capture({
    event: 'user_signed_up',
    distinctId: '[user distinct id]',
    groups: { company: 'company_id_in_your_db' }
})
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-php"
        }}>{`PostHog::capture(array(
    'distinctId' => '[user distinct id]',
    'event' => 'user_signed_up',
    '$groups' => array("company" => "company_id_in_your_db")
));
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-ios"
        }}>{`posthog.group( "company", groupKey: "company_id_in_your_db")
// For this session, any event captured after calling \`posthog.group\` will be associated with company \`company_id_on_your_db\`
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-android"
        }}>{`PostHog.with(this).group("company", "company_id_in_your_db") 
// For this session, any event captured after calling \`posthog.group\` will be associated with company \`company_id_on_your_db\`
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-segment"
        }}>{`// You'll always need to pass through the $groups object for Segment, even for analytics.js
analytics.track('user_signed_up', {
    $groups: { segment_group: 'company_id_in_your_db' }
})
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-bash"
        }}>{`curl -v -L --header "Content-Type: application/json" -d '{
    "api_key": "<ph_project_api_key>",
    "event": "user_signed_up",
    "distinct_id": "[user distinct id]",
    "properties": {
        "$groups": {"company": "company_id_in_your_db"}
    }
}' <ph_instance_address>/capture/
`}</code></pre>
    </MultiLanguage>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      